import React from "react";

export default function GlobalSpinner(props) {
  return props.isGlobalSpinnerOn ? (
    <div className="global-spinner-overlay">
      <strong>Loading data...</strong>
      <div
        className="spinner-border text-info"
        role="status"
        aria-hidden="true"
      ></div>
    </div>
  ) : null;
}
